export default "__VITE_ASSET__6RGmaxXS__"